import { createApiInstance } from './config'

const api = createApiInstance()

/**
 * 统计相关API
 */

/**
 * 获取用户活跃统计数据
 * @param {string} game - 游戏名称（可选）
 * @returns {Promise} API响应
 */
export function getUserActivityStatistics(game = null) {
  const params = {}
  if (game && game.trim() !== '') {
    params.game = game.trim()
  }
  
  console.log('统计API调用参数:', { game, params })
  return api.get('/statistics/user-activity', { params })
}

/**
 * 获取支持的游戏列表
 * @returns {Promise} API响应
 */
export function getSupportedGames() {
  console.log('调用游戏列表API: /statistics/games')
  return api.get('/statistics/games')
}

/**
 * 获取指定时间段内的活跃用户列表
 * @param {string} game - 游戏名称
 * @param {number} intervalMinutes - 时间间隔（分钟）
 * @param {number} page - 页码（可选，默认1）
 * @param {number} pageSize - 每页大小（可选，默认100）
 * @returns {Promise} API响应
 */
export function getActiveUsersList(game, intervalMinutes, page = 1, pageSize = 100) {
  return api.get('/statistics/active-users', {
    params: {
      game,
      intervalMinutes,
      page,
      pageSize
    }
  })
}

/**
 * 获取版本统计信息
 * @param {string} game - 游戏名称
 * @param {number} intervalMinutes - 时间间隔（分钟，可选，默认60）
 * @returns {Promise} API响应
 */
export function getVersionStatistics(game, intervalMinutes = 60) {
  return api.get('/statistics/version-statistics', {
    params: {
      game,
      intervalMinutes
    }
  })
}
